// Tiny IndexedDB wrapper for local-first Ponderr Notebook pages.
const DB_NAME = "ponderr_notebook";
const STORE = "pages";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "page_id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function idbPutPage(page) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(page);
    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}

export async function idbGetPage(pageId) {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx = db.transaction(STORE, "readonly");
    const rq = tx.objectStore(STORE).get(pageId);
    rq.onsuccess = () => resolve(rq.result || null);
    rq.onerror = () => resolve(null);
  });
}

export async function idbAllPages() {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx = db.transaction(STORE, "readonly");
    const rq = tx.objectStore(STORE).getAll();
    rq.onsuccess = () => resolve(rq.result || []);
    rq.onerror = () => resolve([]);
  });
}

// Lightly-obfuscated client-side storage for the personal Gemini key.
const KEY_LS = "ponderr_gemini_key";
export function saveLocalKey(k) {
  try { localStorage.setItem(KEY_LS, k ? btoa(k) : ""); } catch { /* ignore */ }
}
export function loadLocalKey() {
  try { const v = localStorage.getItem(KEY_LS); return v ? atob(v) : ""; } catch { return ""; }
}
